import Intercom from '@intercom/messenger-js-sdk';

export default function AnonymousIntercomeMessenger() { 
  Intercom({ 
    app_id: 'yrwsw9zp',
  });

  return ''
} 